var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 116,
    viewBox: "0 0 110 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76127 48.9111C3.42623 51.4046 5.89643 55.258 7.42341 56.8731L14.9123 65.9557L17.7453 69.3967L31.3615 85.9294L36.0603 64.452L23.0828 53.0825L42.6663 35.4367L46.7287 14.8063L25.9099 32.6193L19.2116 38.1951L5.76127 48.9111Z",
    fill: "url(#paint0_radial_308_45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76127 48.9111C3.42623 51.4046 5.89643 55.258 7.42341 56.8731L14.9123 65.9557L17.7453 69.3967L31.3615 85.9294L36.0603 64.452L23.0828 53.0825L42.6663 35.4367L46.7287 14.8063L25.9099 32.6193L19.2116 38.1951L5.76127 48.9111Z",
    stroke: "#979797",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76127 48.9111C3.42623 51.4046 5.89643 55.258 7.42341 56.8731L14.9123 65.9557L17.7453 69.3967L31.3615 85.9294L36.0603 64.452L23.0828 53.0825L42.6663 35.4367L46.7287 14.8063L25.9099 32.6193L19.2116 38.1951L5.76127 48.9111Z",
    stroke: "#979797",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76127 48.9111C3.42623 51.4046 5.89643 55.258 7.42341 56.8731L14.9123 65.9557L17.7453 69.3967L31.3615 85.9294L36.0603 64.452L23.0828 53.0825L42.6663 35.4367L46.7287 14.8063L25.9099 32.6193L19.2116 38.1951L5.76127 48.9111Z",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.701 72.1352C107.114 69.5769 104.203 65.1407 102.446 63.2423L93.7646 52.6538L90.4802 48.6426L74.6947 29.37L70.7476 52.6294L85.5505 66.1701L65.1333 84.0317L61.8347 106.41L83.5919 88.4621L90.6007 82.8586L104.701 72.1352Z",
    fill: "url(#paint1_radial_308_45)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.701 72.1352C107.114 69.5769 104.203 65.1407 102.446 63.2423L93.7646 52.6538L90.4802 48.6426L74.6947 29.37L70.7476 52.6294L85.5505 66.1701L65.1333 84.0317L61.8347 106.41L83.5919 88.4621L90.6007 82.8586L104.701 72.1352Z",
    stroke: "#979797",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.701 72.1352C107.114 69.5769 104.203 65.1407 102.446 63.2423L93.7646 52.6538L90.4802 48.6426L74.6947 29.37L70.7476 52.6294L85.5505 66.1701L65.1333 84.0317L61.8347 106.41L83.5919 88.4621L90.6007 82.8586L104.701 72.1352Z",
    stroke: "#979797",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.701 72.1352C107.114 69.5769 104.203 65.1407 102.446 63.2423L93.7646 52.6538L90.4802 48.6426L74.6947 29.37L70.7476 52.6294L85.5505 66.1701L65.1333 84.0317L61.8347 106.41L83.5919 88.4621L90.6007 82.8586L104.701 72.1352Z",
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0826 4.21933L36.4514 95.3359L53.477 112.823L69.2186 21.6178L56.0826 4.21933Z",
    fill: "url(#paint2_linear_308_45)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0826 4.21933L36.4514 95.3359L53.477 112.823L69.2186 21.6178L56.0826 4.21933Z",
    stroke: "#979797",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0826 4.21933L36.4514 95.3359L53.477 112.823L69.2186 21.6178L56.0826 4.21933Z",
    stroke: "#979797",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0826 4.21933L36.4514 95.3359L53.477 112.823L69.2186 21.6178L56.0826 4.21933Z",
    stroke: "black",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_308_45",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7627 49.0115) rotate(46.605) scale(22.2197 30.0147)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD596",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_308_45",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.7404 69.4842) rotate(-132.787) scale(25.8592 30.8845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_45",
    x1: 36.9236,
    y1: 9.49893,
    x2: 0.037704,
    y2: 76.0552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EBC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3A42A",
    stopOpacity: 0.67
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoM);
export default __webpack_public_path__ + "static/media/logoM.a553acae67a74452b01652863c22a50e.svg";
export { ForwardRef as ReactComponent };